export default "__VITE_ASSET__Cvy7MDHy__"